import { type SvgProps, SvgWrapper } from '../utils';

export function ChevronRightIcon(props: SvgProps) {
  return (
    <SvgWrapper {...props}>
      <path d="M8.46973 5.46967C8.76262 5.17678 9.23738 5.17678 9.53028 5.46967L15.5303 11.4697C15.8232 11.7626 15.8232 12.2373 15.5303 12.5302L9.53028 18.5302C9.23738 18.8231 8.76262 18.8231 8.46973 18.5302C8.17684 18.2373 8.17684 17.7626 8.46973 17.4697L13.9395 11.9999L8.46973 6.53022C8.17684 6.23732 8.17684 5.76256 8.46973 5.46967Z" />
    </SvgWrapper>
  );
}
